// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1uMP-","title":"InfoRow_title__8nwnk"};